// lightJoinContext.js: keeps an ArguMentor Light share code (/free/light?join=CODE)
// through sign-in. See ../joinContext.js.
import { createJoinContext } from '../joinContext.js';

// /free/together is the public path; /free/light links sent before the rename still work.
const light = createJoinContext(['/free/together', '/free/light'], 'argumentor-pending-light-join');
export const getPendingLightJoin = light.get;
export const clearPendingLightJoin = light.clear;
